import type { DelimiterItem } from '../model';

export const DELIM: DelimiterItem = { type: 'delimiter' } as const;

export const hasCC = (groups: string[]) =>
  groups.includes('CommandCenter') || groups.includes('Admin');

export const hasStats = (groups: string[]) =>
  groups.includes('Statistics') || groups.includes('Admin');

export const cleanDelimiters = <T extends { type: string }>(
  items: T[],
): T[] => {
  const out: T[] = [];
  let lastWasDelim = true;
  for (const it of items) {
    if (it.type === 'delimiter') {
      if (!lastWasDelim) {
        out.push(it);
        lastWasDelim = true;
      }
    } else {
      out.push(it);
      lastWasDelim = false;
    }
  }
  if (out.length && out[out.length - 1].type === 'delimiter') {
    out.pop();
  }
  return out;
};
